import React, {Component} from 'react';
import {Redirect} from "react-router";
import chrono_logo from '../img/logo_small.png';
import $ from 'jquery';
import CryptoJS from 'crypto-js';

import {withTranslation} from "react-i18next";
import {withCookies} from 'react-cookie';

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            authenticated: false,
            platformSwitch: false,
            userID: -1,
        };

        this.login = this.login.bind(this);
        this.getUser = this.getUser.bind(this);
        this.clearCookies = this.clearCookies.bind(this);
        this.handleSwitchPlatform = this.handleSwitchPlatform.bind(this);
    }

    /* LIFE CYCLE */
    componentDidMount() {
        $('.loading').fadeIn();
        if (this.props.match) {
            this.getUser({
                lang: this.props.match.params.lang,
                user_id: this.props.match.params.userID,
            });
        } else {
            this.setState({
                authenticated: false,
            }, () => {
                this.login(null, null);

            });
        }
    }

    /* HANDLERS */
    handleSwitchPlatform(e) {
        this.setState({
            platformSwitch: true,
        });
    }

    clearCookies() {
        Object.keys(this.props.cookies.getAll()).map((key) => {
            this.props.cookies.remove(key);
            return true;
        });
    }

    getUser(hash) {
        try {

            let lang = CryptoJS.AES.decrypt(hash.lang.replace(/Por21Ld/g, '/'), process.env.REACT_APP_SECRET_KEY).toString(CryptoJS.enc.Utf8);
            let user = CryptoJS.AES.decrypt(hash.user_id.replace(/Por21Ld/g, '/'), process.env.REACT_APP_SECRET_KEY).toString(CryptoJS.enc.Utf8);

            // Change language to the same as the platform
            if (lang) {
                this.props.cookies.set("lang", lang, {"path": "/", "maxAge": (4 * 24 * 60 * 60)});
                this.props.i18n.changeLanguage(lang);
            }

            const helper = this;
            $.ajax({
                type: 'POST',
                url: serverIP + ":" + backendPort + '/users/getUser',
                dataType: 'json',
                data: {
                    userID: user,
                },
                success: function (data) {
                    if (data && data[0]) {
                        helper.login(data[0].email, data[0].password);
                    } else {
                        helper.login(null, null);
                    }
                },
                error: function (a, b, c) {
                    helper.login(null, null);
                    $('.loading').fadeOut();
                    console.log(a, b, c);
                }
            });
        } catch (e) {
            this.login(null, null);
            $('.loading').fadeOut();
            console.log(e);
        }
    }

    login(email, hash) {
        if (email) {
            const helper = this;
            $.ajax({
                type: 'POST',
                url: serverIP + ":" + backendPort + '/users/login',
                dataType: 'json',
                data: {
                    email: email,
                    password: hash,
                },
                success: function (data) {
                    if (data["auth"]["code"] === 200) {
                        let tempLang = helper.props.cookies.get("lang");
                        helper.clearCookies();
                        helper.props.cookies.set("authToken", data["auth"]["headers"].authorization, {"path": "/", "maxAge": (4 * 24 * 60 * 60)});
                        helper.props.cookies.set("lang", tempLang, {"path": "/", "maxAge": (4 * 24 * 60 * 60)});

                        let privsArr = data.privileges.split("_");
                        for (let i = 0; i < privsArr.length; i++) {
                            privsArr[i] = parseInt(privsArr[i]);
                        }

                        helper.setState({
                            authenticated: true,
                            userID: data.userID,
                            privileges: privsArr,
                        }, () => {
                            $('.loading').fadeOut();
                        });

                    } else {
                        helper.setState({
                            authenticated: false,
                            userID: null,
                            privileges: null,
                        }, () => {
                            helper.clearCookies();
                            $('.loading').fadeOut();
                        });
                    }
                }, error: function (err) {
                    helper.setState({
                        authenticated: false,
                        userID: null,
                        privileges: null,
                    }, () => {
                        console.log(err);
                        helper.clearCookies();
                        $('.loading').fadeOut();
                    });
                }
            });
        } else {
            this.setState({
                authenticated: false,
                userID: null,
                privileges: null,
            }, () => {
                $('.loading').fadeOut();
                this.clearCookies();
            });
        }
    }

    render() {
        return (
            <>
                <div className="loading">
                    <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                </div>
                {(this.state.authenticated) ? (
                    <Redirect
                        to={{
                            pathname: "/sessionChoice",
                            state: {
                                userID: this.state.userID,
                                privileges: this.state.privileges,
                            }
                        }}
                    />
                ) : (
                    (this.state.platformSwitch || this.props.match === undefined) ? (
                        <Redirect
                            to={{
                                pathname: "/external-redirect/platform"
                            }}
                        />
                    ) : (
                        !(this.state.userID < 0) ? (
                            <div className={"container w3-animate-fading"}>
                                <div className={"App_modernContainer"} style={{maxWidth: 450, paddingBottom: 80}}>
                                    <div className={"text-center"}>
                                        <img width={"70%"} src={chrono_logo} alt={"LOGO"}/>
                                    </div>
                                    <hr/>
                                    <h1 className={"text-center App_title"}>{this.props.t("wrongLoginData")}</h1>
                                    <br/>
                                    <button
                                        onClick={this.handleSwitchPlatform}
                                        className={"btn btn-block App_white_text button"}
                                        style={{background: "#ed2126", color: "#FFFFFF"}}
                                    >
                                        <span><i className={"fas fa-external-link-alt"}/></span>
                                        <span>{this.props.t("switchPlatform")}</span>
                                    </button>
                                </div>
                            </div>
                        ) : null
                    )
                )}
            </>
        );
    }
}

export default withTranslation("translations")(withCookies(Login));
